import { FC, MouseEvent } from 'react';
import { connect } from 'react-redux';
import { DropdownButtonItem, DropdownButton } from '@salecycle/ui-component-library';

import { Actions as RulesetActions, Selectors as RulesetSelectors } from 'sections/campaigns/state/rulesets';
import { State } from 'store';
import { Actions } from '../../../state/editor';
import { useTranslation } from 'react-i18next';

interface IOwnProps {
  rulesetId: string;
}

interface IStateProps extends IOwnProps {
  nextRulesetId: string;
  isNewRuleset: boolean;
}

interface IDispatchProps {
  clone: (rulesetId: string) => void;
  delete: (rulesetId: string) => void;
  discardLocal: (rulesetId: string) => void;
}

export type IProps = IStateProps & IDispatchProps;

export const RulesetDropdown: FC<IProps> = props => {
  const { t } = useTranslation('campaigns');
  const onCloneClick = (event: MouseEvent) => {
    event.stopPropagation();
    props.clone(props.rulesetId);
  };

  const onDeleteClick = (event: MouseEvent) => {
    event.stopPropagation();
    props.isNewRuleset ? props.discardLocal(props.rulesetId) : props.delete(props.rulesetId);
  };

  return (
    <DropdownButton variation="clean" icon="ellipsis-v" menuPlacement="right">
      <DropdownButtonItem onClick={onCloneClick}>
        {t('campaigns:editor.rulesets.rulesetDropdown.clone')}
      </DropdownButtonItem>
      <DropdownButtonItem onClick={onDeleteClick}>
        {t('campaigns:editor.rulesets.rulesetDropdown.delete')}
      </DropdownButtonItem>
    </DropdownButton>
  );
};

const mapState = (state: State, ownProps: IOwnProps): IStateProps => ({
  ...ownProps,
  nextRulesetId: RulesetSelectors.newRulesetId(state),
  isNewRuleset: RulesetSelectors.isNew(state, ownProps.rulesetId),
});

const actions: IDispatchProps = {
  clone: RulesetActions.cloneRuleset,
  delete: Actions.markForDeletion,
  discardLocal: RulesetActions.discardLocal,
};

export default connect(mapState, actions)(RulesetDropdown);
